import { createAction } from '@reduxjs/toolkit'
import reducer from './reducer'

export const {
  saveFiltersAndSorter,
  fetchArcAdsSuccess,
  fetchArcAdsFailure,
  fetchArcAdDetailsSuccess,
  fetchArcAdDetailsFailure,
  fetchArcAdSourcesSuccess,
  fetchArcAdSourcesFailure,
  fetchArcCategoriesSuccess,
  fetchArcCategoriesFailure,
  startSaving,
  finishSaving,
  clearData,
  setImagePreview,
  clearImagePreview,
  updateArcAdSuccess,
  updateArcAdFailure,
  fetchAffiliateNetworksSuccess,
  fetchAffiliateNetworksFailure,
  convertClickUrlSuccess,
  convertClickUrlFailure,
  startConverting,
  finishConverting,
  clearConvertedUrl,
} = reducer.actions

export const fetchArcAds = createAction('arcAds/fetchArcAds')
export const fetchArcAdDetails = createAction('arcAds/fetchArcAdDetails')
export const fetchArcAdSources = createAction('arcAds/fetchArcAdSources')
export const fetchArcCategories = createAction('arcAds/fetchArcCategories')
export const createArcAd = createAction('arcAds/createArcAd')
export const updateArcAd = createAction('arcAds/updateArcAd')
export const deleteArcAd = createAction('arcAds/deleteArcAd')
export const fetchAffiliateNetworks = createAction('arcAds/fetchAffiliateNetworks')
export const convertClickUrl = createAction('arcAds/convertClickUrl')
export const cloneArcAd = createAction('arcAds/cloneArcAd')